const bind = function () {
    $('.switchCustomerBtn').on('click', function (e) {
        if ($(e.target).is(':button, button > img')) {
            const el = $(this);
            const addressCard = el.closest('.address-card');
            window.spinner.show(el);
            addressCard.find('.set-primary').trigger('submit');
        }
    });

    $('.address-card:not(.active)').on('click', function (e) {
        if (!$(e.target).is(':button, button > img')) {
            const el = $(this);
            if (!el.hasClass('disabled-item')) {
                window.spinner.show(el);
                el.find('.set-primary').trigger('submit');
            }
        }
    });
}

export {
    bind,
}
